// @ts-nocheck

import { BetslipOptionsActionTypes } from '../types/actions/betslipOptions';

export const addBetToFavorites = (betslipId) => ({
  type: BetslipOptionsActionTypes.ADD_BET_TO_FAVORITES,
  payload: {
    betslipId,
  },
});

export const removeBetFromFavorites = (betslipId) => ({
  type: BetslipOptionsActionTypes.REMOVE_BET_FROM_FAVORITES,
  payload: {
    betslipId,
  },
});

export const hideBet = (betslipId) => ({
  type: BetslipOptionsActionTypes.HIDE_BET,
  payload: {
    betslipId,
  },
});

export const removeHideBet = (betslipId) => ({
  type: BetslipOptionsActionTypes.REMOVE_HIDE_BET,
  payload: {
    betslipId,
  },
});
